export default "__VITE_ASSET__DhWoL64h__"